import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Download, FileSpreadsheet, FileText } from "lucide-react";
import { downloadExport } from "@/components/reports/reportUtils";
import { api } from "@/lib/api";

export function ExportButtons({ path, params, filenameBase, testIdPrefix }) {
  const onExport = async (fmt) => {
    try {
      await downloadExport(api, path, params, filenameBase, fmt);
    } catch {
      toast.error("No se pudo exportar el reporte");
    }
  };
  return (
    <div className="flex gap-2">
      <Button variant="outline" size="sm" onClick={() => onExport("csv")} className="gap-1" data-testid={`${testIdPrefix}-export-csv`}>
        <Download className="h-4 w-4" /> CSV
      </Button>
      <Button variant="outline" size="sm" onClick={() => onExport("xlsx")} className="gap-1" data-testid={`${testIdPrefix}-export-xlsx`}>
        <FileSpreadsheet className="h-4 w-4" /> Excel
      </Button>
      <Button variant="outline" size="sm" onClick={() => onExport("pdf")} className="gap-1" data-testid={`${testIdPrefix}-export-pdf`}>
        <FileText className="h-4 w-4" /> PDF
      </Button>
    </div>
  );
}
